import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AssetsHandlerComponent } from '@features/assets-handler/assets-handler.component';

@Component({
    selector: 'formly-field-asset-upload',
    templateUrl: './asset-upload.component.html',
    imports: [AssetsHandlerComponent]
})
export class FormlyFieldAssetUploadComponent extends FieldType<FieldTypeConfig> {

  get maxNumberOfFiles(): number {
    if (typeof this.props['multiple'] === 'number') {
      return this.props['multiple'];
    }

    return this.props['multiple'] ? 20 : 1;
  }

  handleChanges(urls: string[]): void {
    if (!urls?.length) {
      return this.formControl.setValue(null);
    }

    if (Array.isArray(urls)) {

      if (this.maxNumberOfFiles === 1) {
        const url = urls[0];
        this.formControl.setValue(url);
      } else {
        this.formControl.setValue(urls);
      }

    } else {
      this.formControl.setValue(urls);
    }

    this.form.markAsDirty();
  }
}
